const CompanyPhone = '070-4410-8836';
const CompanyEmail = 'support@datepop.co.kr';
const CompanyAddress = '서울 서초구 나루터로 62, 일신빌딩 7층';
const CoupleCount = 500;
const DownloadCount = CoupleCount * 10000;
const ShopCount = 2000;

const FacebookSubscriber = 900000;
const NaverPostFollwer = 50000;
const NaverBlogVisit = 20000;
const NaverRankPercent = 1;

const ContractRate = 85;

export {
  CompanyPhone,
  CompanyEmail,
  CompanyAddress,
  CoupleCount,
  DownloadCount,
  ShopCount,
  FacebookSubscriber,
  NaverPostFollwer,
  NaverBlogVisit,
  NaverRankPercent,
  ContractRate,
};
